import React, { useState } from 'react';
import { Popover, Typography, Box, Link } from '@material-ui/core';
import { useIntl } from 'react-intl';
import messages from "../messages";

interface Props {
  children: React.ReactElement;
  onHereClick: () => void;
  className?: string;
}

const CustomTooltip: React.FC<Props> = ({ children, onHereClick, className }) => {
  const { formatMessage } = useIntl();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleHereClick = () => {
    handleClose();
    onHereClick(); 
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <span className={className} onClick={handleOpen} style={{ display: "inline-flex", cursor: "pointer" }}>{children}</span>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        keepMounted
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Box p={2} maxWidth={280}>
          <Typography color="textPrimary">
            {formatMessage(messages.stripe_myFitWorld_new_pricing_starts_from)}
          </Typography>
          <Typography color="textPrimary">
            {formatMessage(messages.stripe_myFitWorld_new_pricing_check_details)}{" "}
            <Link component="button" onClick={handleHereClick} style={{ fontSize: 16, marginBottom: 3 }}>
              {formatMessage(messages.stripe_myFitWorld_here_link)}
            </Link>
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default CustomTooltip;
